<div class="flex flex-col flex-1 justify-between p-4">
  <div class="flex justify-between content-center items-center flex-row">
    <h1 class="txp-h1">Engagement details</h1>
    <mat-icon class="close-icon self-start mt-1" (click)="closeDialog()">close</mat-icon>
  </div>
  <div class="flex flex-col flex-1">
    <mat-form-field appearance="outline">
      <mat-label>Transaction ID</mat-label>
      <input
        matInput
        type="text"
        matTooltip="Updating the transaction ID is not permitted"
        [disabled]="data.disableTransactionId"
        [matTooltipDisabled]="!data.disableTransactionId"
        [(ngModel)]="engagement.transactionId"
      />
    </mat-form-field>
    @if (engagement.engagementType === 'payment') {
      <mat-form-field appearance="outline">
        <mat-label>Payment reason</mat-label>
        <mat-select [(ngModel)]="engagement.reason">
          @for (reason of paymentReasons; track reason) {
            <mat-option [value]="reason">
              {{ reason }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    <mat-form-field appearance="outline">
      <mat-label>Notes</mat-label>
      <textarea
        matInput
        placeholder="Please add supporting notes here, including the chosen charity name, if funds are being donated."
        [style.height]="'100px'"
        [(ngModel)]="engagement.notes"
      ></textarea>
    </mat-form-field>
  </div>
  <div class="flex flex-col gap-4 justify-self-end cursor-pointer">
    <div>
      <p [copy-clipboard]="engagement.engagementId ?? ''">
        <span class="font-bold">Engagement ID:</span>
        <span>
          {{ engagement.engagementId }}
        </span>
      </p>
      <p [copy-clipboard]="engagement.expertId">
        <span class="font-bold">Expert ID:</span>
        <span>
          {{ engagement.expertId }}
        </span>
      </p>
      <p [copy-clipboard]="engagement.opportunityId">
        <span class="font-bold">Opportunity ID:</span>
        <span>
          {{ engagement.opportunityId }}
        </span>
      </p>
    </div>
    <div class="flex flex-1 flex-col gap-2">
      <button mat-raised-button color="secondary" (click)="closeDialog()">Close</button>
      <button mat-raised-button color="primary" (click)="saveChanges()">Save changes</button>
    </div>
  </div>
</div>
